import { useMutation } from '@apollo/client';
import ConfirmDialog from '@website/components/utilities/ConfirmDialog';
import { DeleteLastTripItineraryItemDocument } from '@website/types/graphqlOperations';
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FaSpinner } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';

type Props = {
  onError: (message: string) => void;
  tripID: string;
  itineraryItemId: string;
};

export default function DeleteItineraryItem({
  onError,
  tripID,
  itineraryItemId,
}: Props) {
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);

  const [deleteItem, { loading }] = useMutation(
    DeleteLastTripItineraryItemDocument,
    {
      update(cache) {
        const cacheID = cache.identify({
          __typename: 'TripItineraryItem',
          id: itineraryItemId,
        });
        cache.evict({ id: cacheID });
      },
    },
  );

  async function deleteItineraryItem() {
    try {
      await deleteItem({
        variables: {
          input: {
            tripID,
          },
        },
      });
    } catch (e) {
      onError(
        `Something went wrong while deleting last itinerary item: ${e.toString()}`,
      );
    }
  }

  return (
    <>
      <ConfirmDialog
        title="Delete ItineraryItem?"
        body="Are you sure you want to delete last itinerary item?"
        visible={isConfirmModalVisible}
        setVisible={(visible) => setIsConfirmModalVisible(visible)}
        onConfirmFn={() => deleteItineraryItem()}
      />
      <Button
        aria-label="Delete Item"
        variant="danger"
        disabled={loading}
        className="float-end mb-2 p-0 px-2 pb-1"
        onClick={() => setIsConfirmModalVisible(true)}
      >
        {loading ? (
          <>
            <FaSpinner /> Deleting Item
          </>
        ) : (
          <>
            <MdDelete /> Delete Item
          </>
        )}
      </Button>
    </>
  );
}
